import type { ModuleInjectionTable } from '@open-mercato/shared/modules/widgets/injection'

export const injectionTable: ModuleInjectionTable = {
  'customers.company.detail:details': {
    widgetId: 'participants.injection.customer-participant-summary',
    priority: 35,
  },
  'customers.company.detail:tabs': [{
    widgetId: 'participants.injection.freight-profile-tab',
    kind: 'tab',
    groupLabel: 'participants.tab.title',
    priority: 30,
  }],
}

export default injectionTable
